export function medicalStatus(dateStr) {
  if (!dateStr) return null;
  const d = new Date(`${dateStr.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = Math.round((d - today) / 86400000);
  const fmt = d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
  if (days < 0) return { level: "rojo", days, date: fmt, label: "Caducado", cls: "bg-rose-100 text-rose-700 border border-rose-300" };
  if (days <= 15) return { level: "naranja", days, date: fmt, label: `${days} d`, cls: "bg-orange-100 text-orange-700 border border-orange-300" };
  if (days <= 30) return { level: "amarillo", days, date: fmt, label: `${days} d`, cls: "bg-yellow-100 text-yellow-800 border border-yellow-300" };
  return { level: "ok", days, date: fmt, label: fmt, cls: "bg-emerald-50 text-emerald-700 border border-emerald-200" };
}
